import ComponentModule from "@eisinc/Overrides/Components/WishListCard";

export * from "@eisinc/Overrides/Components/WishListCard";

export default ComponentModule;
